import { createI18n } from 'vue-i18n';
import axios from 'axios';

// Convert flat dot-notation keys to nested objects for vue-i18n
// e.g. {"home.page_title": "Welcome"} => {"home": {"page_title": "Welcome"}}
function unflatten(flat) {
  const result = {};
  for (const key in flat) {
    const parts = key.split('.');
    let current = result;
    for (let i = 0; i < parts.length - 1; i++) {
      if (!current[parts[i]]) current[parts[i]] = {};
      current = current[parts[i]];
    }
    current[parts[parts.length - 1]] = flat[key];
  }
  return result;
}

// Create i18n instance
const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: 'en', // Default language
  fallbackLocale: 'en', // Fallback if translation missing
  messages: {
    en: {} // Start with empty, will be loaded dynamically
  }
});

// Helper function to load translations from API
export async function loadLanguageAsync(languageCode) {
  console.log(`📖 loadLanguageAsync called for: ${languageCode}`);

  // Check if already loaded
  const alreadyLoaded = i18n.global.availableLocales.includes(languageCode) &&
      Object.keys(i18n.global.messages[languageCode] || {}).length > 0;

  if (alreadyLoaded) {
    console.log(`✓ Language ${languageCode} already loaded, just switching locale`);
    console.log(`Current locale before: ${i18n.global.locale.value}`);
    i18n.global.locale.value = languageCode;
    console.log(`Current locale after: ${i18n.global.locale.value}`);
    return languageCode;
  }

  try {
    // Fetch translations from API
    console.log(`🌐 Fetching translations from: /api/translations/${languageCode}`);
    const response = await axios.get(`/api/translations/${languageCode}`, {
      withCredentials: true
    });
    console.log(`📦 API Response:`, response.data);

    // The API returns { language: {...}, translations: {...} }
    // Extract just the translations object
    const flatMessages = response.data.translations || response.data;
    console.log(`📝 Extracted ${Object.keys(flatMessages).length} translation keys`);
    console.log(`Sample keys:`, Object.keys(flatMessages).slice(0, 5));

    // Convert flat dot-notation keys to nested objects for vue-i18n
    const messages = unflatten(flatMessages);

    // Set locale messages
    i18n.global.setLocaleMessage(languageCode, messages);
    console.log(`✓ Set locale messages for ${languageCode}`);

    // Set as current locale
    console.log(`Current locale before: ${i18n.global.locale.value}`);
    i18n.global.locale.value = languageCode;
    console.log(`Current locale after: ${i18n.global.locale.value}`);

    console.log(`✅ Loaded ${Object.keys(messages).length} translations for ${languageCode}`);

    return languageCode;
  } catch (error) {
    console.error(`❌ Error loading language ${languageCode}:`, error);

    // Fallback to English on error
    if (languageCode !== 'en') {
      i18n.global.locale.value = 'en';
    }

    throw error;
  }
}

export default i18n;
